/**
 * Author: 雷凌 <lieling.cp@alibaba-inc.com>
 *         吴邹杰 <zoujie.wzj@alibaba-inc.com>
 */


    // 在SVN迁移至Git版本的过程中, 在JS中加载CSS是不允许的, 所以Git项目的alpha-svn中CSS的必须单独加载
    /* seajs.use('css/6v/run/common/alitalk-new/alitalk.css'); */

    var $ = require("@alife/alpha-jquery/jquery");
    var AliTalkUnit = require("./alitalk-unit");

    // 旺旺状态缓存, 防止多次渲染时, 重复请求旺旺状态
    var STATUS_CACHE = {};

    // Alitalk组件有两种状态
    // 一种是由页面提供, 可以在dom元素的data-status中找到, 它使用下面的状态映射表
    var ALL_STATUS = {
        '0': 'OFFLINE',
        '1': 'LEISURE',
        '2': 'BUSY',
        '3': 'LEAVE',
        '4': 'BUSY',
        '5': 'LEAVE',
        '6': 'BUSY',
        '30': 'LEISURE',
        '33': 'LEISURE',
        '34': 'BUSY',
        '35': 'LEAVE',
        '36': 'BUSY',
        '37': 'LEAVE',
        '38': 'BUSY',
        '40': 'OFFLINE',
        '41': 'OFFLINE',
        '125': 'OFFLINE',
        '126': 'OFFLINE',
        '127': 'OFFLINE'
    };

    // 另一种状态由atmamos接口提供, 它使用下面的状态映射表
    var SIMPLE_STATUS = {
        '0': 'OFFLINE',
        '1': 'LEISURE',
        '6': 'OFFLINE',
        '7': 'BUSY',
        '8': 'LEAVE'
    };
        
    // 为函数绑定指定的参数
    function bindArgs(func) {
        var args = Array.prototype.slice.call(arguments, 1);
        
        return function () {
            func.apply(null, args);
        };
    }

    /*
     * DOM示例
     * <div class="alitalk-unit" data-uid="8pctgRBMALOVaMP97BynsZAKX2pgQEq7" data-pid="1747174866"></div>
     *
     * 调用示例
     * AliTalk.renderList('body .alitalk-unit');
     */
    var AliTalk = function() {};

    AliTalk.prototype.renderList = function(elements, config) {

        var nodeList = $(elements).toArray();
        var deferreds = [];
        

        // 必须使用嵌套配置合并
        config = $.extend(true, {

            // Alitalk的UI展示类型(normal/unit)
            uiType: 'normal',

            // ATM点击来源
            from: '1',

            // 页面是否使用iSearch版本的状态映射
            // 如果为true, 就会直接使用元素上的status属性
            iSearchVer: false,

            // 在线和离线回调
            onlineCallback: false,
            offlineCallback: false,

            // 是否默认就初始化WebATM
            needWebATM: false,

            // 渲染生成的ATM链接的宽度
            width: 'auto',

            // 绑定元素的data属性默认名称
            usrData: {
                uid: 'uid',                 // 用户ID(加密后的)
                pid: 'pid',                 // 联系ID
                from: 'from',               // ATM点击来源
                status: 'status',            // 状态名称
                eid: 'eid',                  // 加密产品ID
                extra : 'extra'     // 额外参数
            },

            // ATM元素的提示方案与CSS类名
            usrText: ['Chat Now!', 'Leave Messages', 'I\'m Away', 'I\'m Busy'],
            usrTipText: ['Chat with me', 'Please Leave a Message', 'Please Leave a Message', 'Please Leave a Message'],
            usrCls: ['atm-online', 'atm-grey', 'atm-away', 'atm-busy']
        }, config);

        
        
        // 非iSearchVer版本, 需要另外从atmamos接口获取状态
        if (!config.iSearchVer) {
            var apiUrl = '//atmamos.alicdn.com/muliuserstatusx2.atc?beginnum=';
            var statusName = config.usrData.status;
            var uidName = config.usrData.uid;
            var index = 0;
            var part;

            // filter nodeList from cache
            var cached = [];
            for (var i = nodeList.length - 1; i >= 0; i --) {
                var node = $(nodeList[i]);
                var uid = node.data(uidName);

                if (uid in STATUS_CACHE) {
                    // add status
                    node.data(statusName, STATUS_CACHE[uid]);

                    cached.push(node);
                    nodeList.splice(i, 1);
                }
            }

            if (cached.length > 0) {
                renderUnits(cached);
            }

            // 状态API返回的是一个online全局数组, 此处需要进行初始化
            window.online = [];

            // 由于API的限制, 必须分批获取ATM的状态信息
            while ((part = fetchPart(nodeList)).ids.length > 0) {
                var url = apiUrl + index + ';' + part.ids.join(';');

                var subDeferred = $.getScript(url, bindArgs(function (nodes, idList, index) {

                    var idNum = idList.length;
                    var statusMap = {};
                    var i;

                    for (i = 0; i < idNum; i ++) {
                        statusMap[idList[i]] = window.online[index + i];
                    }

                    // 将状态绑定在元素的data属性上, 与iSearchVer版本保持一致
                    var nodesNum = nodes.length;

                    for (i = 0; i < nodesNum; i ++) {
                        var node = $(nodes[i]);
                        var uid = node.data(uidName) || '';

                        node.data(statusName, statusMap[uid] || 0);
                        
                        // write status cache
                        if (uid) {
                            STATUS_CACHE[uid] = statusMap[uid] || 0;
                        }
                    }

                    renderUnits(nodes);
                }, part.nodes, part.ids, index));

                deferreds.push(subDeferred);

                index += part.nodes.length;
            }
        } else {
            renderUnits(nodeList);
        }

        // 返回一个jQuery Promise接口
        return $.when.apply($, deferreds).promise();

        // ATM状态接口有如下限制:
        // 1. Query参数不能超过1024个字节
        // 2. 一次性传入ID数不能超过50个
        function fetchPart(list) {
            var uidName = config.usrData.uid;
            var nodes = [];
            var idList = [];
            var totalLength = 26;    // 初始长度: `beginnum=0`(10)和后面的jQuery自动加的时间戳`&_=1234567890123`(16)

            while (idList.length < 50 && list.length > 0) {
                var eid = $(list[0]).data(uidName) || '';

                // 亮灯服务器query部分总长不超过1024, 为保险起见(可能还有其它参数), 只取最大长度为1000
                if (eid.length + totalLength > 1000) {
                    break;
                } else {
                    nodes.push(list.shift());

                    if (idList.indexOf(eid) < 0) {
                        idList.push(eid);

                        totalLength += eid.length + 1; // 分隔符(';')长度为1
                    }
                }
            }

            return {
                nodes: nodes,
                ids: idList
            };
        }

        function renderUnits(nodes) {
            var map = config.iSearchVer ? ALL_STATUS : SIMPLE_STATUS;
            var statusName = config.usrData.status;
            var fromName = config.usrData.from;
            var uidName = config.usrData.uid;
            var pidName = config.usrData.pid;
            var eidName = config.usrData.eid;
            var extraName = config.usrData.extra;
            var length = nodes.length;
            var i;

            for (i = 0; i < length; i ++) {
                var node = $(nodes[i]);
                var statusCode = node.data(statusName);
                var status = map[statusCode] || 'OFFLINE';

                // 防止重复绑定alitalk-unit
                if (node.data('alitalk-unit')) {
                    continue;
                }

                var unit = new AliTalkUnit({
                    status: status,
                    statusCode: statusCode,
                    element: node,
                    uiType: config.uiType,
                    enMemberId: node.data(uidName),
                    productId: node.data(pidName),
                    enProductId: node.data(eidName),
                    from: node.data(fromName) || config.from,  // 优先使用DOM中的from数据,
                    onlineCallback: config.onlineCallback,
                    offlineCallback: config.offlineCallback,
                    domdotCallback: config.domdotCallback,
                    renderCallback: config.renderCallback,
                    width: config.width,
                    usrData: config.usrData,
                    usrText: config.usrText,
                    usrTipText: config.usrTipText,
                    usrCls: config.usrCls,
                    extra:node.data(extraName)
                });

                node.data('alitalk-unit', unit);
            }
        }
    };

    module.exports = new AliTalk();
